import React, { useState } from 'react';
import { FaChartLine, FaMoneyCheckAlt } from 'react-icons/fa';

import Receivables from './Receivables';
import Sales from './Sales';

import './css/Inventory.css';
import './css/Menu.css';
import './css/MenuNav.css';
import './css/Purchase.css';
import './css/Receivables.css';

/**
 * Finance shell — Sales (today by channel) and Payments (platform receivables / settlements).
 */
const Finance = () => {
  const [subView, setSubView] = useState('sales');

  return (
    <div className="menu inventory-page purchase-page finance-page">
      <div className="menu-nav finance-nav">
        <div
          className="menu-nav__tabs menu-nav__tabs--underline"
          role="tablist"
          aria-label="Finance sections"
        >
          <button
            type="button"
            role="tab"
            aria-selected={subView === 'sales'}
            className={`menu-nav__tab ${subView === 'sales' ? 'is-active' : ''}`}
            onClick={() => setSubView('sales')}
          >
            <FaChartLine className="menu-nav__tab-icon" aria-hidden="true" />
            <span>Sales</span>
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={subView === 'payments'}
            className={`menu-nav__tab ${subView === 'payments' ? 'is-active' : ''}`}
            onClick={() => setSubView('payments')}
          >
            <FaMoneyCheckAlt className="menu-nav__tab-icon" aria-hidden="true" />
            <span>Payments</span>
          </button>
        </div>
      </div>

      <div className="purchase-tab-panel finance-tab-panel">
        <div className="finance-content-panel">
          {subView === 'sales' ? <Sales /> : <Receivables />}
        </div>
      </div>
    </div>
  );
};

export default Finance;
